import React, { forwardRef } from 'react'
import { FormControl, FormControlLabel, Grid, Paper, Radio, RadioGroup, TextField, Typography } from '@material-ui/core'
import { Page, Header, CustomButton, SecaoGenerica } from 'components'
import { IMaskInput } from 'react-imask'
import { Autocomplete } from '@material-ui/lab'
import { MapaCorpo } from '../components/MapaCorpo/MapaCorpo'
import MaterialTable from 'material-table'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import SearchIcon from '@material-ui/icons/Search'
import ClearIcon from '@material-ui/icons/Clear'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import FirstPageIcon from '@material-ui/icons/FirstPage'
import LastPageIcon from '@material-ui/icons/LastPage'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import SaveIcon from '@material-ui/icons/Save'
import { getLabelRegiaoAnatomica } from 'helpers/labels'

import { useStyles } from './ExameMausTratos.styles'
import { useExameMausTratos } from './hooks/useExameMausTratos'

export const ExameMausTratos = (props) => {
  const { route } = props
  const classes = useStyles()

  const {
    params,
    exameMaustratos,
    lesoes,
    setLesoes,
    setSvgElements,
    processando,
    processandoOperacao,
    formState,
    handleChange,
    handleAutocompleteChange,
    handleChangeCampoData,
    handleConfirmar,
    router,
  } = useExameMausTratos()

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      
      {processando || !exameMaustratos ? (
        <Typography variant="body1">carregando...</Typography>
      ) : (
        <MainForm
          exameMaustratos={exameMaustratos}
          lesoes={lesoes}
          processandoOperacao={processandoOperacao}
          formState={formState}
          handleChange={handleChange}
          handleAutocompleteChange={handleAutocompleteChange}
          handleChangeCampoData={handleChangeCampoData}
          handleConfirmar={handleConfirmar}
          router={router}
        >
          <MapaCorpo lesoes={lesoes} setLesoes={setLesoes} setSVGElements={setSvgElements} />
        </MainForm>
      )}
    </Page>
  )
}

const MainForm = (props) => {
  const {
    exameMaustratos,
    lesoes,
    processandoOperacao,
    formState,
    handleChange,
    handleAutocompleteChange,
    handleChangeCampoData,
    handleConfirmar,
    router,
    children,
  } = props

  const classes = useStyles()

  const getLabelLesao = (rowData) => {
    if (rowData.tipo.nome.toLowerCase() === 'outro') {
      return rowData.tipoTextoLivre
    }
    return rowData.tipo.nome
  }

  const getLabelCaracteristicasLesao = (rowData) => {
    const tipos = {
      TIRO: [
        { field: 'pafTipoBorda', label: 'tipo borda' },
        { field: 'pafHaloEnxugo', label: 'halo de enxugo' },
        { field: 'pafAureolaEquimotica', label: 'auréola equimótica' },
        { field: 'pafOrlaEscoriacao', label: 'orla de escoriação' },
        { field: 'pafZonaTatuagem', label: 'zona de tatuagem' },
        { field: 'pafZonaEsfumacamento', label: 'zona de esfumaçamento' },
        { field: 'pafZonaQueimadura', label: 'zona de queimadura' },
        { field: 'pafAspectoEstrelado', label: 'aspecto estrelado' },
        { field: 'pafMarcaCano', label: 'marca de cano' },
      ],
      INCISAO: [
        { field: 'incisaoRegiaoMaisAprofundada', label: 'região mais aprofundada' },
        { field: 'incisaoRegiaoCaudaEscoriacao', label: 'região da cauda de escoriação' },
        { field: 'incisaoBorda', label: 'borda' },
      ],
      PERFUROINCISA: [
        { field: 'perfuroIncisaForma', label: 'forma' },
        { field: 'incisaoBorda', label: 'borda' },
      ],
      QUEIMADURA_ELETRICA: [
        { field: 'tipoQueimaduraEletrica', label: 'tipo da queimadura elétrica' },
        { field: 'metalizacao', label: 'metalizacao' },
        { field: 'eritema', label: 'eritema' },
        { field: 'flictema', label: 'flictema' },
        { field: 'carbonizacao', label: 'carbonizacao' },
        { field: 'necrose', label: 'necrose' },
      ],
      COGUMELO_ESPUMA: [{ field: 'tipoCogumeloEspuma', label: 'tipo do cogumelo de espuma' }],
      SULCO: [
        { field: 'sulcoOrientacao', label: 'orientação' },
        { field: 'sulcoMultiplicidade', label: 'multiplicidade' },
        { field: 'sulcoContinuidade', label: 'continuidade' },
        { field: 'sulcoTonalidade', label: 'tonalidade' },
        { field: 'sulcoTumefeito', label: 'tumefeito' },
        { field: 'sulcoProfundidade', label: 'profundidade' },
        { field: 'sulcoMargensElevadas', label: 'margens elevadas' },
        { field: 'sulcoLeitoDeprimido', label: 'leito deprimido' },
        { field: 'sulcoPeleEnrugada', label: 'pele enrugada' },
      ],
    }

    const tipoLesao = rowData.tipo?.cod?.toUpperCase()
    const config = tipos[tipoLesao]

    if (!config) return ' - '

    return config
      .filter((item) => rowData[item.field])
      .map((item) => item.label)
      .join(', ') || ' - '
  }

  return (
    <>
      <SecaoGenerica titulo="HISTÓRICO" spacing={2}>
        <Grid container spacing={2} className={classes.fieldGroup}>
          <Grid item sm={12} xs={12} lg={12} md={12}>
            <Typography>Especificar como o periciando se declara com relação à raça, gênero, etnia, deficiência, contexto social, familiar, antecedentes médicos e psicológicos, trabalho, educação, entre outros, a partir do relato: </Typography>
            <TextField value={formState.autoDeclaracao} name="autoDeclaracao" variant="outlined" fullWidth onChange={handleChange} />
          </Grid>

          <Grid item sm={12} xs={12} lg={6} md={6}>
            <Typography>Motivo do exame: </Typography>
            <TextField value={formState.motivoExame} name="motivoExame" variant="outlined" fullWidth onChange={handleChange} />
          </Grid>

          <Grid item sm={12} xs={12} lg={6} md={6}>
            <Typography>Local da ocorrência: </Typography>
            <TextField value={formState.localOcorrencia} name="localOcorrencia" variant="outlined" fullWidth onChange={handleChange} />
          </Grid>

          <Grid item sm={12} xs={12} lg={3} md={3}>
            <Typography>Data da Ocorrência: </Typography>
            <IMaskInput className={classes.data} value={formState.dataOcorrencia} mask="00/00/0000" placeholder="dd/mm/aaaa" onInput={(e) => handleChangeCampoData('ocorrencia', e.target.value)} />
            {!formState.dataOcorrenciaValida && <Typography className={classes.dataInvalida}>data inválida</Typography>}
          </Grid>
          <Grid item sm={12} xs={12} lg={3} md={3}>
            <Typography>Hora da ocorrência: </Typography>
            <IMaskInput className={classes.data} value={formState.horaOcorrencia} mask="00:00" placeholder="00:00" onInput={(e) => handleAutocompleteChange('horaOcorrencia', e.target.value)} />
          </Grid>
          <Grid item sm={12} xs={12} lg={6} md={6}>
            <Typography>Instrumento causador da ofensa: </Typography>
            <Autocomplete
              value={formState.instrumentoOfensa}
              name="instrumentoOfensa"
              noOptionsText="Sem informações"
              options={['Contudente', 'Cortante', 'Perfurante', 'Perfuro-contundente', 'Perfuro-cortante', 'Corto-contundente', 'Outros']}
              onChange={(event, newValue) => {
                handleAutocompleteChange('instrumentoOfensa', newValue)
              }}
              renderInput={(paramsInput) => <TextField {...paramsInput} variant="outlined" required placeholder="Selecionar..." />}
            />
          </Grid>

          <Grid item sm={12} xs={12} lg={6} md={6}>
            <Typography>Nome do agressor: </Typography>
            <TextField value={formState.nomeAgressor} name="nomeAgressor" variant="outlined" fullWidth onChange={handleChange} />
          </Grid>
          <Grid item sm={6} xs={12} lg={3} md={3}>
            <Typography>Número de golpes: </Typography>
            <IMaskInput className={classes.data} value={formState.numeroGolpes} mask="000" onInput={(e) => handleAutocompleteChange('numeroGolpes', e.target.value)} />
          </Grid>

          <Grid item sm={12} xs={12} lg={12} md={12}>
            <Typography>Ataque surpresa: </Typography>
            <FormControl component="fieldset" fullWidth>
              <RadioGroup aria-label="ataque-surpresa" value={formState.ataqueSurpresa} name="ataqueSurpresa" onChange={handleChange} style={{ display: 'flex', flexDirection: 'row' }}>
                <FormControlLabel control={<Radio />} value="true" label="Sim" style={{ paddingRight: '40px' }} />
                <FormControlLabel control={<Radio />} value="false" label="Não" />
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid item sm={6} xs={12} lg={3} md={3}>
            <Typography>Contenção da vítima </Typography>
            <FormControl component="fieldset" fullWidth>
              <RadioGroup aria-label="contencao-vitima" value={formState.contencaoVitima} name="contencaoVitima" onChange={handleChange} style={{ display: 'flex', flexDirection: 'row' }}>
                <FormControlLabel control={<Radio />} value="true" label="Sim" style={{ paddingRight: '40px' }} />
                <FormControlLabel control={<Radio />} value="false" label="Não" />
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid item sm={9} xs={12} lg={9} md={9}>
            <Typography>Quem conteve: </Typography>
            <TextField value={formState.quemConteve} name="quemConteve" variant="outlined" fullWidth onChange={handleChange} />
          </Grid>

          <Grid item sm={12} xs={12} lg={12} md={12}>
            <Typography>Versão do periciando: </Typography>
            <TextField value={formState.versaoPericiando} name="versaoPericiando" multiline minRows={3} variant="outlined" fullWidth onChange={handleChange} />
          </Grid>

          <Grid item sm={12} xs={12} lg={12} md={12}>
            <Typography>Descrição da dor: </Typography>
            <TextField value={formState.descricaoDor} name="descricaoDor" multiline minRows={3} variant="outlined" fullWidth onChange={handleChange} />
          </Grid>
        </Grid>
      </SecaoGenerica>

      <SecaoGenerica titulo="DESCRIÇÃO DO EXAME" spacing={2}>
        <Grid container spacing={2} className={classes.fieldGroup}>
          <Grid item sm={12} xs={12} lg={3} md={3}>
            <Typography>Data da realização do exame: </Typography>
            <IMaskInput className={classes.data} value={formState.dataRealizacaoExame} mask="00/00/0000" placeholder="dd/mm/aaaa" onInput={(e) => handleChangeCampoData('realizacaoExame', e.target.value)} />
            {!formState.dataRealizacaoExameValida && <Typography className={classes.dataInvalida}>data inválida</Typography>}
          </Grid>
          <Grid item sm={12} xs={12} lg={3} md={3}>
            <Typography>Hora do início do exame: </Typography>
            <IMaskInput className={classes.data} value={formState.horaInicioExame} mask="00:00" placeholder="00:00" onInput={(e) => handleAutocompleteChange('horaInicioExame', e.target.value)} />
          </Grid>
          <Grid item sm={12} xs={12} lg={3} md={3}>
            <Typography>Hora do término do exame: </Typography>
            <IMaskInput className={classes.data} value={formState.horaTerminoExame} mask="00:00" placeholder="00:00" onInput={(e) => handleAutocompleteChange('horaTerminoExame', e.target.value)} />
          </Grid>
          <Grid item sm={12} xs={12} lg={6} md={6}>
            <Typography>Local de realização do exame: </Typography>
            <TextField value={formState.localExame} name="localExame" variant="outlined" fullWidth onChange={handleChange} />
          </Grid>
          <Grid item sm={12} xs={12} lg={6} md={6}>
            <Typography>Periciando acompanhado por (nome completo e função): </Typography>
            <TextField value={formState.acompanhantePericiando} name="acompanhantePericiando" variant="outlined" fullWidth onChange={handleChange} />
          </Grid>
          <Grid item sm={12} xs={12} lg={12} md={12}>
            <Typography>Pessoas presentes no momento do exame (nome completo e função): </Typography>
            <TextField value={formState.pessoasPresentesExame} name="pessoasPresentesExame" variant="outlined" fullWidth onChange={handleChange} />
          </Grid>

          <Grid item sm={6} xs={12} lg={3} md={3}>
            <Typography>Consentimento esclarecido </Typography>
            <FormControl component="fieldset" fullWidth>
              <RadioGroup aria-label="consentimentoEsclarecido" value={formState.consentimentoEsclarecido} name="consentimentoEsclarecido" onChange={handleChange} style={{ display: 'flex', flexDirection: 'row' }}>
                <FormControlLabel control={<Radio />} value="true" label="Sim" style={{ paddingRight: '40px' }} />
                <FormControlLabel control={<Radio />} value="false" label="Não" />
              </RadioGroup>
            </FormControl>
          </Grid>
          {formState.consentimentoEsclarecido === 'false' ? (
            <Grid item sm={12} xs={12} lg={9} md={9}>
              <Typography>Motivo do não esclarecimento: </Typography>
              <TextField value={formState.motivoSemConsentimentoEsclarecido} name="motivoSemConsentimentoEsclarecido" variant="outlined" fullWidth onChange={handleChange} />
            </Grid>
          ) : (
            <Grid item lg={9} md={9} />
          )}

          <Grid item sm={6} xs={12} lg={3} md={3}>
            <Typography>O periciando foi sujeito a contenção durante o exame: </Typography>
            <FormControl component="fieldset" fullWidth>
              <RadioGroup aria-label="necessarioContencao" value={formState.necessarioContencao} name="necessarioContencao" onChange={handleChange} style={{ display: 'flex', flexDirection: 'row' }}>
                <FormControlLabel control={<Radio />} value="true" label="Sim" style={{ paddingRight: '40px' }} />
                <FormControlLabel control={<Radio />} value="false" label="Não" />
              </RadioGroup>
            </FormControl>
          </Grid>
          {formState.necessarioContencao === 'true' && (
            <Grid item sm={12} xs={12} lg={9} md={9}>
              <Typography>Motivo da contenção (registrar tipo e forma de uso da contenção): </Typography>
              <TextField value={formState.motivoContencao} name="motivoContencao" variant="outlined" fullWidth onChange={handleChange} />
            </Grid>
          )}
        </Grid>
      </SecaoGenerica>

      <SecaoGenerica titulo="EXAME DIRETO" spacing={2}>
        <Grid container spacing={2} className={classes.fieldGroup}>
          <Grid item md={12} sm={12} xs={12}>
            {children}
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <MaterialTable
              components={{
                Container: (propsTable) => <Paper {...propsTable} elevation={0} style={{ padding: '0px' }} />,
              }}
              localization={{
                pagination: {
                  labelDisplayedRows: '{from}-{to} de {count}',
                  labelRowsSelect: 'linhas',
                  nextTooltip: 'Página seguinte',
                  previousTooltip: 'Página anterior',
                  lastTooltip: 'Última página',
                  firstTooltip: 'Primeira página',
                },
                toolbar: {
                  nRowsSelected: '{0} linha(s) selecionadas',
                  searchPlaceholder: 'Buscar',
                },
                header: {
                  actions: 'Ações',
                },
                body: {
                  emptyDataSourceMessage: 'Nenhuma lesão registrada',
                  filterRow: {
                    filterTooltip: 'Filtro',
                  },
                },
              }}
              title=""
              columns={[
                {
                  title: 'Identificador',
                  render: (rowData) => <Typography className={classes.linhaTabela}>Lesão {rowData.tableData.id + 1}</Typography>,
                },
                {
                  title: 'Tipo da lesão',
                  render: (rowData) => <Typography className={classes.linhaTabela}>{getLabelLesao(rowData)}</Typography>,
                },
                {
                  title: 'Características específicas',
                  render: (rowData) => <Typography className={classes.linhaTabela}>{getLabelCaracteristicasLesao(rowData)}</Typography>,
                },
                {
                  title: 'Região',
                  render: (rowData) => <Typography className={classes.linhaTabela}>{getLabelRegiaoAnatomica(rowData.regioes[0])}</Typography>,
                },
                {
                  title: 'Observações',
                  render: (rowData) => <Typography>{rowData.observacoes || ' - '}</Typography>,
                },
              ]}
              data={lesoes || []}
              options={{
                actionsColumnIndex: -1,
                search: true,
                toolbar: false,
                pageSize: 10,
                searchFieldStyle: {
                  flexGrow: 1,
                  height: 42,
                  display: 'flex',
                  alignItems: 'center',
                },
                headerStyle: {
                  backgroundColor: '#f4f6f8',
                  fontSize: '12px',
                },
                paging: false,
              }}
              icons={{
                SortArrow: forwardRef((propsSortArrow, ref) => <ArrowDownwardIcon {...propsSortArrow} ref={ref} />),
                Search: forwardRef((propsSearch, ref) => <SearchIcon {...propsSearch} ref={ref} />),
                ResetSearch: forwardRef((propsResetSearch, ref) => <ClearIcon {...propsResetSearch} ref={ref} />),
                NextPage: forwardRef((propsNextPage, ref) => <NavigateNextIcon {...propsNextPage} ref={ref} />),
                PreviousPage: forwardRef((propsPreviousPage, ref) => <NavigateBeforeIcon {...propsPreviousPage} ref={ref} />),
                FirstPage: forwardRef((propsFirstPage, ref) => <FirstPageIcon {...propsFirstPage} ref={ref} />),
                LastPage: forwardRef((propsLastPage, ref) => <LastPageIcon {...propsLastPage} ref={ref} />),
              }}
              style={{
                padding: '16px',
                fontSize: '11px !important',
                textAlign: 'left',
                fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                fontWeight: '400',
                lineHeight: '21px',
                letterSpacing: '-0.05px',
                verticalAlign: 'inherit',
              }}
            />
          </Grid>
        </Grid>
      </SecaoGenerica>

      <SecaoGenerica titulo="EXAME INDIRETO" spacing={2}>
        <Grid container spacing={2} className={classes.fieldGroup}>
          <Grid item sm={12} xs={12} lg={12} md={12}>
            <Typography>Exames de diagnóstico ou complementares realizados </Typography>
            <TextField value={formState.exameIndireto} name="exameIndireto" variant="outlined" fullWidth onChange={handleChange} />
          </Grid>
        </Grid>
      </SecaoGenerica>

      <SecaoGenerica titulo="DISCUSSÃO E CONCLUSÃO" spacing={2}>
        <Grid container spacing={2} className={classes.fieldGroup}>
          <Grid item sm={12} xs={12} lg={12} md={12}>
            <Typography>Perito conclui que o grau de consistência entre o relato de tortura ou outros tratamentos cruéis, desumanos ou degradantes e os achados médico-legais físicos é: </Typography>
            <FormControl component="fieldset" fullWidth>
              <RadioGroup aria-label="conclusao" value={formState.conclusao} name="conclusao" onChange={handleChange}>
                <FormControlLabel
                  control={<Radio />}
                  value="POUCO_CONSISTENTE"
                  label="Pouco consistente: os sintomas e constatações do exame físico são pouco ou não consistentes com os fatos relatados sobre a prática de tortura ou outros tratamentos cruéis, desumanos ou degradantes."
                  style={{ paddingBottom: '40px', paddingTop: '20px' }}
                />
                <FormControlLabel
                  control={<Radio />}
                  value="CONSISTENTE"
                  label="Consistente: os sintomas e constatações do exame físico são consistentes com os fatos relatados sobre a prática de tortura ou outros tratamentos cruéis, desumanos ou degradantes, podendo ter sido causados pelos traumas descritos e perfazem reações habituais ou típicas de stress intenso dentro do contexto cultural e social da pessoa. Porém são evidências atípicas, podendo haver outras causas possíveis."
                  style={{ paddingBottom: '40px' }}
                />
                <FormControlLabel
                  control={<Radio />}
                  value="ALTAMENTE_CONSISTENTE"
                  label="Altamente consistente: os sintomas e constatações do exame físico são bastante consistentes com os fatos relatados sobre a prática de tortura ou outros tratamentos cruéis, desumanos ou degradantes, podendo ter sido causados pelos traumas descritos e perfazem reações habituais ou típicas de stress intenso dentro do contexto cultural e social da pessoa. Existem poucas causas alternativas possíveis."
                  style={{ paddingBottom: '40px' }}
                />
                <FormControlLabel
                  control={<Radio />}
                  value="CONSISTENCIA_TIPICA"
                  label="Consistência típica: os sintomas e constatações do exame físico correspondem em alto grau com os fatos relatados sobre a prática de tortura ou outros tratamentos cruéis, desumanos ou degradantes, sendo tipicamente causadas pelos traumas descritos e são reações típicas de stress intenso dentro do contexto cultural e social da pessoa. Não obstante, podem existir outras causas possíveis, embora sejam muito raras."
                  style={{ paddingBottom: '40px' }}
                />
                <FormControlLabel
                  control={<Radio />}
                  value="DIAGNOSTICO"
                  label="Diagnóstico de: os sintomas e constatações do exame físico apenas podem ter sido causados pelas formas descritas no relato da pessoa examinada, não havendo outras causas possíveis."
                  style={{ paddingBottom: '40px' }}
                />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      </SecaoGenerica>

      <Grid container justifyContent="space-between" className={classes.botoesFormulario}>
        <Grid item>
          <CustomButton
            variant="outlined"
            onClick={() => router.history.goBack()}
            startIcon={<ArrowBackIcon />}
          >
            Voltar
          </CustomButton>
        </Grid>
        <Grid item>
          <CustomButton
            variant="contained"
            color="primary"
            isLoading={processandoOperacao}
            disabled={!formState.dataOcorrenciaValida || !formState.dataRealizacaoExameValida}
            onClick={handleConfirmar}
            startIcon={<SaveIcon />}
          >
            Confirmar
          </CustomButton>
        </Grid>
      </Grid>
    </>
  )
}
